import React, {useState} from 'react';
import {
    SpeedDial,
    SpeedDialIcon,
    SpeedDialAction,
} from "@material-ui/lab";
import {
    Backdrop,
    makeStyles,
} from "@material-ui/core";
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import PersonIcon from '@material-ui/icons/Person';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DescriptionIcon from '@material-ui/icons/Description';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import CloudIcon from '@material-ui/icons/Cloud';
import theme from '../.././styles/theme';

const useLeadNavStyles = makeStyles({
    backDrop: {
        zIndex: 99
    },
    speedDial: {
        position: 'fixed',
        '&.MuiSpeedDial-directionUp': {
            bottom: theme.spacing(15),
            right: theme.spacing(5),
        },
    },
});

const useSpeedDialAction = makeStyles({
    staticTooltipLabel: {
        width: '200px'
    }
});


const LeadPurchaseRequestNavigationMenu = ({hasDecisionLog, hasRawRequestLogs, hasLoanRedirect}) => {
    const [open, setOpen] = useState(false);
    const leadNavClasses = useLeadNavStyles();
    const speedDialActionClasses = useSpeedDialAction();
    const actions = [
        {icon: <VerticalAlignTopIcon/>, name: 'Page Top', enable: true},
        {icon: <PersonIcon/>, name: 'Person', enable: true},
        {icon: <DescriptionIcon/>, name: 'Lead Purchase Decision Log', enable: hasDecisionLog},
        {icon: <ReceiptIcon/>, name: 'Raw Request Log', enable: hasRawRequestLogs},
        {icon: <PlayArrowIcon/>, name: 'Redirect Data', enable: hasLoanRedirect},
        {icon: <CloudIcon/>, name: 'Cloudwatch Logs', enable: true},
    ];

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <div className={leadNavClasses.root}>
            <Backdrop
                className={leadNavClasses.backDrop}
                open={open}
            />
            <SpeedDial
                className={leadNavClasses.speedDial}
                ariaLabel="Lead Navigation"
                icon={<SpeedDialIcon/>}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
                direction="up"
            >
                {actions.map((action) => (
                    action.enable &&
                    <SpeedDialAction
                        classes={speedDialActionClasses}
                        title={action.name}
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        tooltipOpen={true}
                        onClick={() => {
                            const id = action.name.replace(/\s+/g, '-').toLowerCase();
                            const yOffset = -10;
                            const element = document.getElementById(id);
                            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                            window.scrollTo({top: y, behavior: 'smooth'});

                            handleClose();
                        }}
                    />
                ))}
            </SpeedDial>
        </div>
    );
};

export default LeadPurchaseRequestNavigationMenu;